import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {Tooltip} from "@mui/material";
import {Delete} from "@mui/icons-material";

import {del} from "actions/feed/delete";

import {primaryColor} from "assets/jss/main";

DeleteFeedButton.propTypes = {
    feed: PropTypes.object.isRequired,
};

function DeleteFeedButton({feed, ...props}) {
    return (
        <div onClick={() => props.del(feed)}>
            <Tooltip title={<FormattedMessage id={"feed.list.table.tooltip.delete"}/>}>
                <Delete style={{color: primaryColor, cursor: "pointer"}}/>
            </Tooltip>
        </div>
    );
}

const mapDispatchToProps = dispatch => ({
    del: feed => dispatch(del(feed)),
});

export default connect(
    null,
    mapDispatchToProps
)(DeleteFeedButton);
